module.exports = __webpack_public_path__ + "img/biter-run-1.41fdfe19.png";